import { Box, Paper, Typography } from "@mui/material";
import { useState } from "react";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { processSteps } from "./processSteps";

export const MobileStepper: React.FC = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "100%",
        mx: "auto",
        overflow: "hidden",
        px: { xs: 0.1, sm: 0.25, md: 0.4 },
        "& .swiper": {
          width: "100%",
          overflow: "hidden",
          paddingBottom: "26px",
        },
        "& .swiper-slide": {
          width: "100% !important",
          boxSizing: "border-box",
          height: "auto",
        },
        "& .swiper-pagination": {
          bottom: "0px !important",
        },
        "& .swiper-pagination-bullet": {
          backgroundColor: "rgba(128,51,65,0.28)",
          opacity: 1,
        },
        "& .swiper-pagination-bullet-active": {
          backgroundColor: "#803341",
        },
      }}
    >
      <Typography
        component="h3"
        sx={{
          textAlign: "center",
          mb: { xs: 2, sm: 2.4 },
          px: { xs: 0.6, sm: 0 },
          fontFamily: '"Cormorant Garamond", serif',
          fontSize: { xs: "1.9rem", sm: "2.15rem", md: "2.3rem" },
          fontWeight: 700,
          color: "#30161b",
          lineHeight: 1.08,
        }}
      >
        A Structured, Transparent Workflow
      </Typography>

      <Swiper
        modules={[Autoplay, Pagination]}
        autoplay={{ delay: 2600, disableOnInteraction: false }}
        pagination={{ clickable: true }}
        loop
        slidesPerView={1}
        spaceBetween={10}
        onSlideChange={(swiper: any) => setActiveIndex(swiper.realIndex)}
      >
        {processSteps.map((step, index) => (
          <SwiperSlide key={step.label}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: "20px",
                p: { xs: 1.6, sm: 2.2, md: 2.6 },
                background:
                  "linear-gradient(152deg, rgba(255,255,255,0.9), rgba(255,247,243,0.78))",
                border: "1px solid rgba(128,51,65,0.16)",
                boxShadow: "0 12px 24px rgba(24,10,12,0.1)",
                textAlign: "center",
                minHeight: { xs: 196, sm: 214, md: 224 },
                height: "100%",
              }}
            >
              <Box
                sx={{
                  width: 36,
                  height: 36,
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 1.3,
                  fontFamily: '"Manrope", sans-serif',
                  fontWeight: 700,
                  fontSize: "0.82rem",
                  color: "#fff",
                  background:
                    index === activeIndex
                      ? "linear-gradient(135deg, #803341 0%, #a44a50 100%)"
                      : "rgba(128,51,65,0.34)",
                }}
              >
                {index + 1}
              </Box>

              <Typography
                sx={{
                  fontFamily: '"Cormorant Garamond", serif',
                  color: "#32181e",
                  fontSize: { xs: "1.38rem", sm: "1.6rem" },
                  fontWeight: 700,
                  lineHeight: 1.1,
                }}
              >
                {step.label}
              </Typography>

              <Typography
                sx={{
                  mt: 0.9,
                  fontFamily: '"Manrope", sans-serif',
                  color: "rgba(53,33,36,0.82)",
                  fontSize: { xs: "0.86rem", sm: "0.9rem", md: "0.94rem" },
                  lineHeight: { xs: 1.58, sm: 1.68 },
                }}
              >
                {step.description}
              </Typography>
            </Paper>
          </SwiperSlide>
        ))}
      </Swiper>
    </Box>
  );
};
